"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareWaitlistContractsInitialValues = exports.waitlistEditContractFilter = void 0;
const waitlistEditContractFilter = ({ title, description, imageUrl, contractStatus }) => ({
    title,
    description,
    imageUrl,
    contractStatus,
});
exports.waitlistEditContractFilter = waitlistEditContractFilter;
const prepareWaitlistContractsInitialValues = ({ id, title, description, imageUrl, contractStatus, address, }) => {
    return {
        id,
        title,
        description,
        address,
        contractStatus,
        imageUrl,
    };
};
exports.prepareWaitlistContractsInitialValues = prepareWaitlistContractsInitialValues;
//# sourceMappingURL=schemas.js.map